namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_file_attach, {
		flex: { wrap: 'wrap' },
		alignItems: 'center',
		gap: $mol_gap.text,

		Name: {
			padding: $mol_gap.text,
			minWidth: 0,
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
			wordBreak: 'break-word',
			flex: { grow: 1, shrink: 1, basis: 0 },
		},
		Delete_row: {
			flex: { basis: '100%' },
		},

	} )
	
}
